"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var letterSpacings = {
    "regular": "0em",
    "badgeSmall": "0.01em",
    "badgeDefault": "0.025em"
};
exports.default = letterSpacings;
//# sourceMappingURL=letterSpacings.js.map